import React from 'react';

import { Button } from '$partials/ui';
import IconArrow from '$partials/icons/icon-arrow';
import { formatLinkBlockToUrl } from '$utilities/data';
import { GeneralEnquiryDialog } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').OfficeDetailsColumn}
 */

const OfficeDetailsColumn = ({
    offices,
    officesHeading,
    officesSubheading
}) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const handleWhatsAppClick = (/** @type {string} */ secondaryPhone) => {
        if (secondaryPhone) {
            const phone = secondaryPhone.replace(/\D/g, '');
            window.open(`https://api.whatsapp.com/send?phone=${phone}`, '_blank');
        }
    };

    return (
        <section className='theme-light bg-main-background pt-32 pb-88 sm:pt-40 sm:pb-60 md:pb-116 md:pt-96'>
            <div className='layout-container layout-site-outer-padding'>

                {officesHeading && (
                    <h2 className='type-style-2 md:w-4/12 mb-16'>
                        {officesHeading}
                    </h2>
                )}

                {officesSubheading && (
                    <h2 className='type-style-body-r md:w-4/12'>
                        {officesSubheading}
                    </h2>
                )}

                <div className='col-wrapper mt-32'>
                    <div className='grid grid-cols- sm:grid-cols-2 1 md:grid-cols-3 gap-y-24'>
                        {offices?.edges?.length > 0 && (
                            <>
                                {offices?.edges?.map((item, index) => {
                                    const office = item?.node;
                                    return (

                                        <div
                                            className={`flex text-main-text-primary justify-between items-start flex-col col-padding ${index % 3 !== 2 ? 'md:border-r md:border-main-border' : ''}`}
                                            key={office.id || index}>
                                            <h3 className='type-style-3 mb-16'>
                                                {office?.title}
                                            </h3>
                                            <div
                                                className='type-style-eyebrow'
                                                dangerouslySetInnerHTML={{ __html: office?.address}} />
                                            <Button
                                                as='a'
                                                className='type-style-eyebrow mt-16 flex items-center'
                                                href={office?.url}>
                                                <span>
                                                    {'See More'}
                                                </span>
                                                <IconArrow className='ml-8 inline-block h-[7px]'/>
                                            </Button>
                                            <div className='type-style-eyebrow mt-24 w-full'>
                                                {office?.primaryPhoneNumber && (
                                                    <div className='border-t border-main-border py-16'>
                                                        <a
                                                            className='flex items-center justify-between w-full'
                                                            href={`tel:${formatLinkBlockToUrl(office?.primaryPhoneNumber)}`}>
                                                            <span>
                                                                {office?.primaryPhoneNumber?.phone}
                                                            </span>
                                                            <IconArrow className='ml-8 inline-block h-[7px]'/>
                                                        </a>
                                                    </div>
                                                )}

                                                {office?.secondaryPhoneNumber && (
                                                    <div className='border-t border-main-border py-16'>
                                                        <Button
                                                            as='a'
                                                            className='flex items-center justify-between w-full'
                                                            onClick={() => handleWhatsAppClick(office?.secondaryPhoneNumber?.phone)}>
                                                            <span>
                                                                {'WHATSAPP'}
                                                            </span>
                                                            <IconArrow className='ml-8 inline-block h-[7px]'/>
                                                        </Button>
                                                    </div>
                                                )}

                                                {office?.officeEmail && (
                                                    <div className='border-t border-main-border py-16'>
                                                        <a
                                                            className='flex items-center justify-between w-full'
                                                            href={formatLinkBlockToUrl(office?.officeEmail)}>
                                                            <span>
                                                                {'EMAIL'}
                                                            </span>
                                                            <IconArrow className='ml-8 inline-block h-[7px]'/>
                                                        </a>
                                                    </div>
                                                )}
                                                <div className='border-t border-main-border py-16'>
                                                    <Button
                                                        className='flex items-center justify-between w-full'
                                                        onClick={() => setIsDialogOpen(true)}>
                                                        <span>
                                                            {'GET IN TOUCH'}
                                                        </span>
                                                        <IconArrow className='ml-8 inline-block h-[7px]'/>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                        {isDialogOpen && (
                            <GeneralEnquiryDialog
                                closeDialog={() => setIsDialogOpen(false)}
                                isOpen={isDialogOpen}/>
                        )}
                    </div>
                </div>
            </div>
        </section>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default OfficeDetailsColumn;
